import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SatModal from '@components/common/satUI/SatModal';

const stateSelector = state => state.customerReducer;

const CustomerInfoPreviousEmail = ({ onSelect }) => {
  const { channelInfo } = $hooks.useUser();
  const { previousData } = useSelector(stateSelector);

  const [isSelectModal, setIsSelectModal] = useState(false);

  const showSelectModal = () => setIsSelectModal(true);
  const hideSelectModal = () => setIsSelectModal(false);

  const handleSelect = email => {
    hideSelectModal();
    onSelect(email);
  };

  const previousEmails = previousData?.emailAddrs;
  const isPreviousEmails = previousEmails?.length > 0;
  const isLP = $utils.checkLP(channelInfo.cdVal);

  return (
    /* @NOTE: LP가 아닐 경우에만 기등록된 정보 등록이 나타나야 한다고 함 */
    !isLP && isPreviousEmails ? (
      <>
        <div className="wrap-not-search">
          <span className="txt">
            고객정보가 존재합니다.
            <br /> 버튼을 눌러 업데이트 하세요
          </span>

          <button
            className="btn-view2 side-r"
            type="button"
            onClick={showSelectModal}
          >
            기 등록된 이메일 주소 등록
          </button>
        </div>

        <CustomerInfoPreviousEmailModal
          emails={previousEmails}
          isOpen={isSelectModal}
          onClose={hideSelectModal}
          onSelect={handleSelect}
        />
      </>
    ) : (
      <></>
    )
  );
};

CustomerInfoPreviousEmail.propTypes = {
  onClose: $propTypes.func,
  onSelect: $propTypes.func,
};

CustomerInfoPreviousEmail.defaultProps = {
  onClose: () => {},
  onSelect: () => {},
};

const CustomerInfoPreviousEmailModal = ({
  emails,
  isOpen,
  onClose,
  onSelect,
}) => {
  return (
    <SatModal
      isPortal
      onCloseButton
      type="list"
      visible={isOpen}
      setVisible={onClose}
    >
      <header className="modal-header">
        <h3 className="layer-tit2">기 등록된 이메일 주소 등록</h3>
      </header>

      <div className="cont">
        <div className="search-wrap customer-pop">
          <ul className="list">
            {emails.map((email, index) => (
              <li key={index} onClick={() => onSelect(email)}>
                <span className="user-info">{email}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </SatModal>
  );
};

CustomerInfoPreviousEmailModal.propTypes = {
  emails: $propTypes.array,
  isOpen: $propTypes.bool,
  onClose: $propTypes.func,
  onSelect: $propTypes.func,
};

CustomerInfoPreviousEmailModal.defaultProps = {
  emails: [],
  isOpen: false,
  onClose: () => {},
  onSelect: () => {},
};

export default CustomerInfoPreviousEmail;
